// extracted by mini-css-extract-plugin
module.exports = {"rssStyle":"RssDirective_rssStyle__KguRO","muted":"RssDirective_muted__YHHiK"};